import "./AsteriskSymbol.scss";
const AsteriskSymbol = ({ asterik = true }) => {
  return <>{asterik ? <span className="asterisk-symbol">*</span> : <span className="asterisk-symbol">&nbsp;</span>}</>;
};

export default AsteriskSymbol;
